<template>
  <div>
    <div class="container">
      <div class="inner">
        <div class="top-bar">
          <h1 class="main-title">{{ $t('view.component.topup.single.header') }}</h1>
          <TopupSingleSteps />
        </div>
        <div v-if="isLoading">
          <div class="with-loading loader-info">
            <Loader />
          </div>
        </div>
        <div v-if="!isLoading">
          <TopupSingleSuccess :transaction="transaction" :topups="topups" v-if="isTopupOk()" />
          <TopupSinglePending :transaction="transaction" :topups="topups" v-if="isTopupWaitingForPayment()" />
          <TopupSingleError :transaction="transaction" :topups="topups" v-if="isTopupError()" />
        </div>
        <TopupBanner />
      </div>
    </div>
  </div>
</template>

<script>
import TopupSingleSteps from '@/orange/components/Topup/Single/Steps'
import TopupSingleError from '@/orange/components/Topup/Single/Error'
import TopupSingleSuccess from '@/orange/components/Topup/Single/Success'
import TopupBackMixin from '@/common/mixins/views/TopupBack.mixin'
import { mapMutations } from 'vuex'
import Loader from '@/orange/components/Loader'
import TopupSinglePending from '@/orange/components/Topup/Single/Pending'
import TopupBanner from '../../../components/common/Banner'

export default {
  name: 'TopupSingleBackView',
  mixins: [TopupBackMixin],
  components: {
    TopupBanner,
    TopupSinglePending,
    Loader,
    TopupSingleSuccess,
    TopupSingleError,
    TopupSingleSteps
  },
  methods: {
    ...mapMutations([
      'SET_TOPUP_STAGE',
      'RESET_TOPUP'
    ])
  },
  created () {
    this.SET_TOPUP_STAGE(4)
  },
  destroyed () {
    this.RESET_TOPUP()
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_topup-main.scss" scoped></style>
<style lang="scss" src="../../../assets/scss/components/_topup-back.scss" scoped></style>
